export const HOMETOWN_GROUP_PNM_CREATE_INIT = 'HOMETOWN_GROUP_PNM_CREATE_INIT';
export const HOMETOWN_GROUP_PNM_CREATE = 'HOMETOWN_GROUP_PNM_CREATE';

export const HOMETOWN_GROUP_PNM_FETCH = 'HOMETOWN_GROUP_PNM_FETCH';
export const HOMETOWN_GROUP_PNM_FETCH_INIT = 'HOMETOWN_GROUP_PNM_FETCH_INIT';
export const HOMETOWN_GROUP_PNM_FETCH_DONE = 'HOMETOWN_GROUP_PNM_FETCH_DONE';
